import { PhysicalThing } from "../physicalThing";
import { deserializeXY } from "../serialization";
import type { XY } from "../xy";
import { ZOrder } from "../zOrder";

export class DestroyedRock extends PhysicalThing {
	static key = "DestroyedRock";
	constructor(xy: XY) {
		super(xy, false);
	}

	getZOrder(): number {
		return ZOrder.CARPET_LIKE;
	}

	static deserialize(data: any): DestroyedRock {
		const d = new DestroyedRock(deserializeXY(data.xy));
		d.visualId = data.visualId;
		return d;
	}
}
